import { Modal } from 'react-bootstrap';
import { formatText } from 'core/i18n';
import React from 'react';
import { useRecordPage } from 'components/sessionTimeOut/SessionOverWrittenModal/hooks/useRecordPage';

export const SessionOverWrittenModal = ({
    showModal,
    modalClass,
    userProfile,
    productsDescription,
    onClickUnderstood,
}) => {
    useRecordPage({ showModal, userProfile, productsDescription });

    return (
        <div>
            <Modal show={showModal} dialogClassName={modalClass} backdrop="static" keyboard={false} animation={false}>
                <Modal.Body>
                    <h5 className="font-heading3">{formatText('session-sessionOverwrittenTitle')}</h5>
                    <span className="dash" />
                    <div className="expired-Message">
                        <p className="font-paragraph2">{formatText('session-sessionOverwrittendMessage')}</p>
                    </div>
                    <hr />
                    <div className="form__buttons">
                        <button className="form__button form__button-secondary" onClick={onClickUnderstood}>
                            {formatText('button-iUnderstood')}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};
